import axios from 'axios'


const instance = axios.create({
    baseURL: 'http://95.216.40.62:88',
})

export default instance